import { Box } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { path } from "src/constants/path";
import {
  allowedToDeleteEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { roleColumns as columns } from "../../Helper";

const GetRoleTableColumns = ({ handleDelete, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.systemRole}/edit/${item.id}`,
            }}
          >
            <button className="btn btn-warning">
              <i className="bx bx-edit"></i>
            </button>
          </Link>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button onClick={() => handleDelete(item)} className="btn btn-danger">
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetRoleTableColumns;
